/*
=ISNUMBER(MATCH(C2, {
  "stock_default_abv",
  "stock_default_abv_hint",
  "support_send_feedback"
}, 0))
*/
const unexpectedTranslationKeys = new Set<string>([
  "task_status",
  "tasks_assign_to_queue",
  "tasks_assign_to_user",
  "tasks_clear_task",
  "tasks_complete_selected_tasks",
  "thurs",
  "ton",
  "trade_portal_contact_password",
  "trade_portal_customisation",
  "trade_portal_item_upload_product_image",
  "trade_portal_settings",
  "trade_portal_upload_logo",
  "transfering_out_qty",
  "true_text",
  "tues",
  "ullages_are_you_sure",
  "ullages_credit_details",
  "ullages_date_reported",
  "ullages_delete_ullage",
  "ullages_destroy_line",
  "ullages_print_selected_labels",
  "ullages_reported_by",
  "ullages_save_changes",
  "ullages_uncomplete_ullage",
  "unit_of_measure_delete",
  "units_kilograms",
  "units_litres",
  "update_subscription_in_a_free_trial_period",
  "update_subscription_manage_billing_and_payment",
  "user_permissions_cannot_allow_action",
  "user_permissions_you_do_not_have_permission_to_view",
  "user_permissions_you_do_not_have_persmission",
  "user_roles_add_new_role",
  "user_roles_api",
  "user_roles_api_description",
  "user_roles_billing",
  "user_roles_billing_description",
  "user_roles_is_locked",
  "users_change_user_password",
  "users_confirm_new_password",
  "users_confirm_new_password_hint",
  "users_confirm_password",
  "users_confirm_password_hint",
  "users_could_not_change_password",
  "users_could_not_delete",
  "users_could_not_disable",
  "users_could_not_load",
  "users_could_not_save",
  "users_create_new",
  "users_delete_confirmation",
  "users_forename",
  "users_invite_pending",
  "users_new_password",
  "users_new_password_hint",
  "users_password",
  "users_password_hint",
  "users_password_must_change",
  "users_surname",
  "users_user_role",
  "validation_invalid_alpha_numeric",
  "validation_invalid_brewman_barcode",
  "validation_invalid_number",
  "validation_must_be_true",
  "validation_required_to_rack",
  "validation_start_mileage_higher_than_end",
  "validation_value_is_not_allowed",
  "vat_code_delete",
  "vessel_delete_confirmation",
  "vessel_logs_empty_vessel",
  "vessel_logs_estimated_litres_remaining",
  "vessel_logs_estimated_litres_total",
  "vessel_logs_measured_litres_remaining",
  "vessel_logs_measured_litres_remaining_hint",
  "vessel_logs_measured_litres_total",
  "vessel_logs_measured_litres_total_hint",
  "vessel_maintenance_ability_required",
  "vessel_maintenance_ability_required_hint",
  "vessel_maintenance_description",
  "vessel_maintenance_description_hint",
  "vessel_maintenance_edit_process",
  "vessel_maintenance_equipment_required",
  "vessel_maintenance_equipment_required_hint",
  "vessel_maintenance_last_updated",
  "vessel_maintenance_maintenance_process",
  "vessel_maintenance_requirements",
  "vessel_new_movement",
  "vessel_no_contents_found",
  "vessel_scheduling_actions_explanation",
  "vessel_scheduling_add_process_to_vessel",
  "vessel_scheduling_no_deviations",
  "vessel_state",
  "vessel_state_set_state",
  "vessels_expected_start_date",
  "view_document_template",
  "weds",
  "woo_commerce_description",
  "woo_commerce_net_price",
  "xero_accounts_link",
  "xero_authentication_successful",
  "zettle_discount_stock_item",
]);

export default unexpectedTranslationKeys;
